<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="invoices.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/sales/invoices/update/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="invoice"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :invoice="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer" v-if="invoices">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="invoices.per_page"
        layout="total, prev, pager, next"
        :total="invoices.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {

  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    invoices() {
      return this.$store.getters['invoice/invoices'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['invoice/tableConfig']));
    },
    loading() {
      return this.$store.getters['invoice/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('invoice/setFilterString', '');
    this.$store.commit('invoice/setCurrentPage', this.currentPage);
    this.$store.commit('invoice/setSorting', this.currentSort);
    await this.$store.dispatch('invoice/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('invoice/setCurrentPage', val);
      this.$store.dispatch('invoice/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('invoice/setSorting', { prop, order, compareType: 'string' });
        this.$store.dispatch('invoice/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
